import React from 'react';
import FullPageLoader from '../Component/Loader/FullPageLoader';
import SaveOfflineLoader from '../Component/Loader/SaveOfflineLoader';

interface LoaderContextType {
  showLoader: boolean;
  setShowLoader: (show: boolean) => void;
  showOfflineSync: boolean;
  setShowOfflineSync: (show: boolean) => void;
  offlineSyncCurrent: number;
  setOfflineSyncCurrent: (current: number) => void;
  offlineSyncTotal: number;
  setOfflineSyncTotal: (total: number) => void;
}

export const LoaderContext = React.createContext<LoaderContextType>({
  showLoader: false,
  setShowLoader: () => {},
  showOfflineSync: false,
  setShowOfflineSync: () => {},
  offlineSyncCurrent: 0,
  setOfflineSyncCurrent: () => {},
  offlineSyncTotal: 0,
  setOfflineSyncTotal: () => {},
});

export const LoaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showLoader, setShowLoader] = React.useState(false);
  const [showOfflineSync, setShowOfflineSync] = React.useState(false);
  const [offlineSyncCurrent, setOfflineSyncCurrent] = React.useState(0);
  const [offlineSyncTotal, setOfflineSyncTotal] = React.useState(0);

  return (
    <LoaderContext.Provider value={{ 
      showLoader, 
      setShowLoader,
      showOfflineSync,
      setShowOfflineSync,
      offlineSyncCurrent,
      setOfflineSyncCurrent,
      offlineSyncTotal,
      setOfflineSyncTotal
    }}>
      {showLoader && <FullPageLoader />}
      {showOfflineSync && (
        <SaveOfflineLoader 
          current={offlineSyncCurrent} 
          total={offlineSyncTotal} 
        />
      )}
      {children}
    </LoaderContext.Provider>
  );
};
